import { useState, useRef, useEffect } from "react";
import Swal from "sweetalert2";
import {
  MaterialReactTable,
  useMaterialReactTable,
  createMRTColumnHelper,
} from "material-react-table";
import { Box, IconButton, Tooltip } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { Form, Input, Label, Button } from "reactstrap";
import JoditEditor from "jodit-react";
import { RiCloseLargeLine } from "react-icons/ri";
import { MdEdit } from "react-icons/md";
import { MdDeleteForever } from "react-icons/md";
import { MdOutlinePublishedWithChanges } from "react-icons/md";
import { MdOutlineUnpublished } from "react-icons/md";
import { FormControl, FormHelperText } from "@mui/material";
import { VscScreenFull } from "react-icons/vsc";
import { MdContentCopy } from "react-icons/md";
import { MdDelete } from "react-icons/md";

import { ToastContainer, toast } from "react-toastify";
import "./blog.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { truncateText } from "../../utils/truncateText";
import { useMediaQuery, useTheme } from "@mui/material";
import axiosInstance from "../../utils/axiosInstance";
import { useFileTypeValidator } from "../../utils/fileTypeValidator";
// import { useSelector } from "react-redux";
const columnHelper = createMRTColumnHelper();

const columns = [
  columnHelper.accessor("image", {
    header: "Banner",
    size: 40,
    Cell: ({ cell }) => (
      <img
        src={cell.getValue()}
        alt="Logo"
        style={{ width: "55px", height: "40px", objectFit: "cover" }}
      />
    ),
  }),
  columnHelper.accessor("title", {
    header: "Blog Title",
    size: 120,
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return (
        <Tooltip title={value} arrow>
          <span>{truncateText(value, 5)}</span>
        </Tooltip>
      );
    },
  }),

  columnHelper.accessor("metatag", {
    header: "Meta Tag",
    size: 120,
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return (
        <Tooltip title={value} arrow>
          <span>{truncateText(value, 5)}</span>
        </Tooltip>
      );
    },
  }),
  columnHelper.accessor("description", {
    header: "Description",
    size: 120,
    // Cell: ({ cell }) => truncateText(cell.getValue(), 5),
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return (
        <Tooltip title={value} arrow>
          <span>{truncateText(value, 5)}</span>
        </Tooltip>
      );
    },
  }),
  columnHelper.accessor("createdAt", {
    header: "Created At",
    size: 200,
    Cell: (cell) => cell.row.original.createdAt.split("T")[0],
  }),
  columnHelper.accessor("updatedAt", {
    header: "Updated At",
    size: 200,
    Cell: (cell) => cell.row.original.updatedAt.split("T")[0],
  }),
];

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

const Blog = () => {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(true); // <-- Loading state

  const roleResponse = useSelector((state) => state.login.login.role);
  const fileInputRef = useRef(null);
  const editor = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLink, setIsOpenLink] = useState(false);
  const [categories, setCategories] = useState([]);
  const [blogList, setBlogList] = useState([]);
  const [categoryInput, setCategoryInput] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [selectedPost, setSelectedPost] = useState(null);
  const [edit, setEdit] = useState({ _id: null, updatePost: false });
  // console.log("edit: ", edit);
  const [image, setImage] = useState(null);
  const [imageList, setImageList] = useState([]);

  const [post, setPost] = useState({
    title: selectedPost?.title || "",
    content: selectedPost?.content || "",
    categoryId: selectedPost?.categoryId || "",
    blog_banner: selectedPost?.blog_banner || "",
    metatag: selectedPost?.metatag || "",
    description: selectedPost?.metatag || "",
  });
  const allowedExtensions = ["png", "jpg"];
  const maxSize = 7 * 1024 * 1024;
  const { validatedFile, error: bannerError } = useFileTypeValidator(
    post.blog_banner,
    allowedExtensions,
    maxSize,
  );

  const [files, setFiles] = useState([]); // State to store selected files
  const allowedExtensionsimg = ["png", "jpg"];
  const maxSizeimg = 5 * 1024 * 1024;
  const { validatedFile: validatedImage, error: imageError } =
    useFileTypeValidator(files?.[0], allowedExtensionsimg, maxSizeimg);

  // Adding a key to force re-render of the file input
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const editPost = (data) => {
    // console.log("data:--------------------------->>>>>", data);
    setPost({
      title: data.title,
      content: data.content,
      categoryId: data.categoryId,
      blog_banner: data.image,
      metatag: data.metatag,
      description: data.description,
    });
    setEdit({
      _id: data._id,
      updatePost: true,
    });
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smooth scrolling
    });
  };

  //-------------logic for show export all data----------

  const rolePermissions = useSelector((state) => state.login.login.role);
  // console.log(
  //   "[[[[[[[[[[[[]]]]]]]]]]]]]]]]]]]]]]]----rolepermision------",
  //   rolePermissions,
  // );
  const canExport = rolePermissions?.Blog?.export === 1;

  console.log("=++++++++++", canExport);

  //-------------------$$----------------------------------

  const handleExportRows = (rows) => {
    const rowData = rows.map((row) => row.original);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };

  const table = useMaterialReactTable({
    columns,
    data: blogList || [],
    state: {
      isLoading: loading, // <--- Use this built-in prop for loading state
    },
    enableRowSelection: true,
    columnFilterDisplayMode: "popover",
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",
    positionActionsColumn: "last",
    enableGlobalFilter: true,
    enableRowActions: roleResponse?.Blog?.write === 1 ? true : false,
    maxSize: 100,
    muiTableHeadCellProps: {
      sx: {
        background: "#DCDAFF",
        fontWeight: "normal",
        zIndex: "auto",
      },
    },
    renderRowActions: ({ cell, row }) => (
      <Box sx={{ display: "flex", gap: "8px" }}>
        {roleResponse?.Blog?.update === 1 && (
          <Tooltip title="Edit Blog">
            <IconButton
              color="primary"
              onClick={() => editPost(cell.row.original)}
            >
              <MdEdit />
              {row._id}
            </IconButton>
          </Tooltip>
        )}
        {roleResponse?.Blog?.delete === 1 && (
          <Tooltip title="Delete Blog">
            <IconButton onClick={() => deletePost(cell.row.original._id)}>
              <MdDeleteForever style={{ color: "red", fontSize: "25px" }} />
            </IconButton>
          </Tooltip>
        )}

        {roleResponse?.Blog?.update === 1 && (
          <Tooltip
            title={cell.row.original.post === 0 ? "Publish" : "UnPublish"}
          >
            <IconButton
              color="success"
              onClick={() =>
                publishBlog(cell.row.original._id, cell.row.original.post)
              }
            >
              {cell.row.original.post === 0 ? (
                <MdOutlinePublishedWithChanges style={{ color: "#4d16a4" }} />
              ) : (
                <MdOutlineUnpublished />
              )}
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        {!isMobile && canExport && (
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            Export All Data
          </Button>
        )}
        {!isMobile && canExport && (
          <Button
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
            startIcon={<FileDownloadIcon />}
          >
            Export Selected Rows
          </Button>
        )}
      </Box>
    ),
  });

  const fieldChanged = (event) => {
    const { name, value } = event.target;
    setPost((prevPost) => ({
      ...prevPost,
      [name]: value,
    }));
  };

  // const uploadFiles = (event) => {
  //   setPost((prevState) => ({
  //     ...prevState,
  //     blog_banner: event.target.files[0],
  //   }));
  // };
  const uploadFiles = (event) => {
    const file = event.target.files[0];

    setPost((prevState) => ({
      ...prevState,
      blog_banner: file,
    }));
  };

  const contentFieldChanged = (data) => {
    setPost({ ...post, content: data });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      // const response = await axios.get(`${baseUrl}/category_List`); // Replace with your API endpoint
      const response = await axiosInstance.get(`/category_List`); // Replace with your API endpoint
      setCategories(response.data.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchBlogList();
  }, []);

  const fetchBlogList = async () => {
    setLoading(true);
    try {
      // const response = await axios.get(`${baseUrl}/blog_List`); // Replace with your API endpoint
      const response = await axiosInstance.get(`/blog_List`); // Replace with your API endpoint
      setBlogList(response.data.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const createCategory = async (categoryName) => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      // const response = await axios.post(
      //   `${baseUrl}/category_create`,
      //   {
      //     categoryname: categoryName,
      //   },
      //   { headers }
      // );
      const response = await axiosInstance.post(
        `/category_create`,
        {
          categoryname: categoryName,
        },
        // { headers }
      );
      setCategories([...categories, response.data]);
      toast.success(response.data.message);
      fetchCategories();
    } catch (error) {}
  };

  // Update an existing category (PUT operation)
  const updateCategory = async (categoryId, categoryName) => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      // const response = await axios.post(
      //   `${baseUrl}/category_Update/${categoryId}`,
      //   { categoryname: categoryName },
      //   { headers }
      // );
      const response = await axiosInstance.post(
        `/category_Update/${categoryId}`,
        { categoryname: categoryName },
        // { headers }
      );
      setCategories([...categories, response.data]);
      toast.success(response.data.message);
      fetchCategories();
    } catch (error) {}
  };

  const createPost = async (event) => {
    event.preventDefault();

    if (post.title.trim() === "") {
      toast.error("Post title is required!");
      return;
    }

    if (post.content.trim() === "") {
      toast.error("Post content is required!");
      return;
    }

    if (post.categoryId === "") {
      toast.error("Select some category!");
      return;
    }
    if (post.metatag === "") {
      toast.error("Post metatag is required!");
      return;
    }
    if (post.description === "") {
      toast.error("Post description is required!");
      return;
    }
    if (post.blog_banner === "") {
      toast.error("Post banner is required!");
      return;
    }

    if (post.blog_banner && !validatedFile) {
      toast.error(bannerError);
      return;
    }

    try {
      if (edit.updatePost) {
        await updatePost();
      } else {
        await doCreatePost(post);
      }
      await fetchBlogList();
      // toast.success("Post Created!");
      setPost({
        title: "",
        content: "",
        categoryId: "",
        blog_banner: "",
        metatag: "",
        description: "",
      });
      // Clear the file input using the ref and force a re-render
      setFileInputKey(Date.now());
    } catch (error) {
      toast.error("Post not created due to some error!");
    }
  };

  const doCreatePost = async (post) => {
    const formData = new FormData();

    for (const key in post) {
      formData.append(key, post[key]);
    }

    const url = `/blogCreate`;
    const headers = {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      // const response = await axios.post(url, formData, { headers });
      const response = await axiosInstance.post(url, formData, { headers });
      const resData = response.data;
      toast.success(response.data.message);
    } catch (error) {
      console.error("Error response:", error.response?.data || error.message);
      throw error;
    }
  };

  const publishBlog = async (_id, post) => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      const newPublishStatus = post == 0 ? 1 : 0;
      const payload = {
        post: newPublishStatus,
      };

      // const response = await axios.post(
      //   `${baseUrl}/blog_Establish/${_id}`,
      //   payload,
      //   { headers }
      // );
      const response = await axiosInstance.post(
        `/blog_Establish/${_id}`,
        payload,
        // { headers }
      );
      if (response.data.data.post === 1) {
        toast.success("Blog Published sucessfully!!!");
      } else {
        toast.warn("Blog UnPublished sucessfully!!!");
      }
      await fetchBlogList();
    } catch (error) {}
  };

  // Update an existing blog post
  const updatePost = async () => {
    const headers = {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      const formData = new FormData();
      for (const key in post) {
        formData.append(key, post[key]);
      }
      // const response = await axios.post(
      //   `${baseUrl}/blog_Update/${edit._id}`,
      //   formData,
      //   { headers }
      // );
      const response = await axiosInstance.post(
        `/blog_Update/${edit._id}`,
        formData,
        { headers },
      );
      toast.success("Post Updated!");

      // Reset state after successful update
      setPost({
        title: "",
        content: "",
        categoryId: "",
        blog_banner: "",
        metatag: "",
        description: "",
      });
      setEdit({ _id: null, updatePost: false });
      // Clear the file input using the ref and force a re-render
      setFileInputKey(Date.now());
      fetchBlogList(); // Refresh the blog list
    } catch (error) {
      toast.error("Post not updated due to some error!");
      console.error(error);
    }
  };

  // Delete a blog post (DELETE operation)
  const deletePost = async (_id) => {
    try {
      // Show SweetAlert2 confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this post!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4d16a4",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      // Check if the user confirmed
      if (result.isConfirmed) {
        // await axios.delete(`${baseUrl}/blog_Delete/${_id}`, {
        //   headers: { Authorization: `Bearer ${token}` },
        // });
        await axiosInstance.delete(`/blog_Delete/${_id}`, {
          // headers: { Authorization: `Bearer ${token}` },
        });
        fetchBlogList();
        Swal.fire("Deleted!", "Your post has been deleted.", "success");
      }
    } catch (error) {
      console.error("Error deleting post:", error);
      Swal.fire("Error!", "There was a problem deleting the post.", "error");
    }
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
    setEditingIndex(null);
  };
  // Function to toggle modal
  const linkToggleModal = () => {
    setIsOpenLink(!isOpenLink);
  };
  const handleInputChange = (e) => {
    setCategoryInput(e.target.value);
  };

  const handleSaveCategory = async (e) => {
    e.preventDefault();
    if (categoryInput.trim() === "") {
      return;
    }

    if (editingIndex !== null) {
      const categoryId = categories[editingIndex]._id;
      await updateCategory(categoryId, categoryInput);
      setCategoryInput("");
      setEditingIndex(null);
    } else {
      await createCategory(categoryInput);
      setCategoryInput("");
      setEditingIndex(null);
    }
  };

  const handleEditCategory = (index) => {
    setEditingIndex(index);
    setCategoryInput(categories[index].categoryName);
    setIsOpen(true);
  };

  // const handleFileChange = (event) => {
  //   setFiles(event.target.files);
  // };

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    setFiles(selectedFiles);
  };

  const handleUpload = async () => {
    if (!validatedImage) {
      toast.error(imageError || "Invalid file type");
      return;
    }
    await handleSubmit(); // Upload files after saving category
  };

  // Delete a blog post (DELETE operation)
  const deleteCategory = async (id) => {
    try {
      // Show SweetAlert2 confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this post!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4d16a4",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      // Check if the user confirmed
      if (result.isConfirmed) {
        // await axios.delete(`${baseUrl}/category_Delete/${id}`, {
        //   headers: { Authorization: `Bearer ${token}` },
        // });
        await axiosInstance.delete(`/category_Delete/${id}`, {
          // headers: { Authorization: `Bearer ${token}` },
        });
        fetchCategories();
        Swal.fire("Deleted!", "Your post has been deleted.", "success");
      }
    } catch (error) {
      Swal.fire("Error!", "There was a problem deleting the post.", "error");
    }
  };

  const handleSubmit = async () => {
    const formData = new FormData(); // Create FormData object

    // Append files to FormData
    for (let i = 0; i < files.length; i++) {
      formData.append("blog_image", files[i]); // Use the field name expected by the server
    }
    const headers = {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      // const response = await axios.post(`${baseUrl}/blog_image`, formData, {
      //   headers,
      // });
      const response = await axiosInstance.post(`/blog_image`, formData, {
        headers,
      });
      if (response.data.error == false) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
      setFiles([]);
      setFileInputKey(Date.now()); // Update key to reset the file input field
      fetchImage();
    } catch (error) {}
  };

  // Handle mouse leave event to remove the hover class
  const handleMouseLeave = (e) => {
    e.currentTarget.removeClass("hover");
  };

  useEffect(() => {
    fetchImage();
  }, []);

  const fetchImage = async () => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      // const response = await axios.get(`${baseUrl}/get_blog_image`, {
      //   headers,
      // }); // Replace with your API endpoint
      const response = await axiosInstance.get(`/get_blog_image`, {
        headers,
      }); // Replace with your API endpoint

      setImageList(response.data.data);
    } catch (error) {}
  };

  // Function to copy the image URL to the clipboard
  const handleCopyImageUrl = (imageUrl) => {
    navigator.clipboard
      .writeText(imageUrl)
      .then(() => {
        toast.success("Image URL copied to clipboard!");
      })
      .catch((err) => {});
  };

  // Function to delete the image using the provided delete API with SweetAlert2 confirmation
  const handleDeleteImage = async (imageId) => {
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    // Show SweetAlert2 confirmation dialog
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this image? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // If confirmed, proceed with the deletion
          // const response = await axios.delete(
          //   `${baseUrl}/blog_image_delete/${imageId}`,
          //   { headers }
          // );
          const response = await axiosInstance.delete(
            `/blog_image_delete/${imageId}`,
            // { headers }
          );

          // After successful deletion, update the state to remove the deleted image from the list
          setImageList((prevImageList) =>
            prevImageList.filter((image) => image._id !== imageId),
          );

          // Show success or error message
          if (response.data.error === false) {
            Swal.fire("Deleted!", response.data.message, "success");
          } else {
            Swal.fire("Error!", response.data.message, "error");
          }

          // Optionally, re-fetch the images after deletion
          fetchImage();
        } catch (error) {
          Swal.fire(
            "Error!",
            "An error occurred while deleting the image.",
            "error",
          );
        }
      }
    });
  };

  // Function to open an image in fullscreen mode
  const handleFullScreen = (imageUrl) => {
    const img = document.createElement("img");
    img.src = imageUrl;
    img.style.width = "100%";
    img.style.height = "100%";

    // Append the image to the body temporarily for fullscreen
    document.body.appendChild(img);

    // Request fullscreen
    if (img.requestFullscreen) {
      img.requestFullscreen();
    } else if (img.mozRequestFullScreen) {
      // Firefox
      img.mozRequestFullScreen();
    } else if (img.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      img.webkitRequestFullscreen();
    } else if (img.msRequestFullscreen) {
      // IE/Edge
      img.msRequestFullscreen();
    }

    // Remove the image after exiting fullscreen
    img.addEventListener("fullscreenchange", () => {
      if (!document.fullscreenElement) {
        img.remove();
      }
    });
  };

  // Function to reset the form
  const handleReset = () => {
    // Reset the state to the initial selectedPost values
    setPost({
      title: selectedPost?.title || "",
      content: selectedPost?.content || "",
      categoryId: selectedPost?.categoryId || "",
      blog_banner: "", // Reset blog_banner field
      metatag: selectedPost?.metatag || "",
      description: selectedPost?.description || "",
    });

    // Clear the file input using the ref and force a re-render
    setFileInputKey(Date.now()); // Change the key to force a fresh file input element
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check

  return (
    <>
      <ToastContainer />
      <div className="shadow-sm" style={{ marginBottom: "2rem" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          {roleResponse?.Blog?.write === 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginBottom: "1rem",
              }}
            >
              <Button
                className="button button-submit rounded-0"
                onClick={toggleModal}
              >
                Create Category
              </Button>
            </div>
          )}

          {isOpen && (
            <div className="modal">
              <div className="modal-content">
                <div className="col-md-12" style={{ display: "flex" }}>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: "70%",
                    }}
                  >
                    <h2 className="category-title">
                      {editingIndex !== null
                        ? "Edit Category"
                        : "Create Category"}
                    </h2>
                  </div>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: "40%",
                    }}
                  >
                    <button className="" onClick={toggleModal}>
                      <RiCloseLargeLine />
                    </button>
                  </div>
                </div>
                <div className="col-md-12" style={{ display: "flex" }}>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      width: "80%",
                      flexDirection: "column",
                    }}
                  >
                    <Label
                      className="label"
                      for="category"
                      style={{
                        color: "#4d16a4",
                      }}
                    >
                      Category Name
                    </Label>
                    <Input
                      type="text"
                      id="category"
                      className="input-field rounded-0"
                      name="category"
                      onChange={handleInputChange}
                      value={categoryInput}
                      placeholder="Enter category name"
                    />
                  </div>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: "20%",
                      marginTop: "30px",
                    }}
                  >
                    <Label className="label" for="category"></Label>
                    <button
                      className="button button-submit rounded-0"
                      onClick={handleSaveCategory}
                      disabled={!categoryInput || categoryInput.length === 0}
                    >
                      {editingIndex !== null ? "Update" : "Create"}
                    </button>
                  </div>
                </div>

                <div className="category-list">
                  <h3
                    className=""
                    style={{
                      color: "#4d16a4",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    Categories:
                  </h3>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <div
                      style={{
                        height: "350px",
                        width: "560px",
                        overflow: "auto",
                      }}
                    >
                      <tbody>
                        {categories?.map((category, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                color: "#4d16a4",
                                width: "86%",
                                padding: "0",
                              }}
                            >
                              {category.categoryName}
                            </td>
                            <td style={{ padding: "0" }}>
                              <button
                                className="btn btn-primary me-2"
                                onClick={() => handleEditCategory(index)}
                              >
                                <MdEdit
                                  style={{ color: "#4d16a4", fontSize: "25px" }}
                                />
                              </button>
                              <button
                                className="btn btn-danger"
                                onClick={() => deleteCategory(category._id)}
                              >
                                <MdDeleteForever
                                  style={{ color: "red", fontSize: "25px" }}
                                />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </div>
                  </table>
                </div>
              </div>
            </div>
          )}
          {roleResponse?.Blog?.write === 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginBottom: "1rem",
              }}
            >
              <Button
                className="button button-submit rounded-0"
                onClick={linkToggleModal}
              >
                Generate Image Link
              </Button>
            </div>
          )}

          {isOpenLink && (
            <div className="modal">
              <div className="modal-content">
                <div className="col-md-12" style={{ display: "flex" }}>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: "70%",
                    }}
                  >
                    <h2 className="category-title">Upload Image</h2>
                  </div>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: "40%",
                    }}
                  >
                    <button className="" onClick={linkToggleModal}>
                      <RiCloseLargeLine />
                    </button>
                  </div>
                </div>
                <div className="col-md-12" style={{ display: "flex" }}>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      width: "80%",
                      flexDirection: "column",
                    }}
                  >
                    <Label
                      className="label"
                      for="blog_image"
                      style={{ color: "#4d16a4", marginTop: "1rem" }}
                    >
                      Upload Files
                    </Label>
                    <Input
                      key={fileInputKey}
                      type="file"
                      id="blog_image"
                      accept="image/*"
                      required
                      multiple
                      onChange={handleFileChange}
                      style={{ padding: "4px" }}
                    />
                  </div>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: "20%",
                      marginTop: "45px",
                    }}
                  >
                    <Label className="label" for="blog_image"></Label>
                    <button
                      className="button button-submit rounded-0"
                      onClick={handleUpload}
                      disabled={files.length === 0} // Disable if no files are selected
                    >
                      Create
                    </button>
                  </div>
                </div>
                <div className="col-md-12" style={{ display: "flex" }}>
                  {imageError ? (
                    <FormHelperText error>{imageError}</FormHelperText>
                  ) : (
                    <FormHelperText>
                      Allowed file type{" "}
                      {allowedExtensions
                        .map((format) => `.${format}`)
                        .join(", ")}{" "}
                      with maxsize {maxSizeimg / (1024 * 1024)} MB
                    </FormHelperText>
                  )}
                </div>

                <div className="category-list col-md-4">
                  {imageList?.map((img, i) => (
                    <figure
                      key={i}
                      className="snip1178 yellow hover"
                      onMouseLeave={handleMouseLeave}
                      style={{
                        height: "120px",
                        width: "120px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img src={img.imageUrl} alt="sample54" />
                      <div className="icons">
                        <a
                          href="#"
                          onClick={() => handleCopyImageUrl(img.imageUrl)}
                        >
                          <i
                            className="ion-ios-printer-outline"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <MdContentCopy style={{ color: "#4a2a7d" }} />
                          </i>
                        </a>
                        <a
                          href="#"
                          onClick={() => handleFullScreen(img.imageUrl)}
                        >
                          <i
                            className="ion-ios-chatboxes-outline"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <VscScreenFull style={{ color: "#4a2a7d" }} />
                          </i>
                        </a>
                        <a href="#" onClick={() => handleDeleteImage(img._id)}>
                          <i
                            className="ion-ios-telephone-outline"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <MdDelete style={{ color: "#4a2a7d" }} />
                          </i>
                        </a>
                      </div>
                    </figure>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
        {roleResponse?.Blog?.write === 1 && (
          <Form onSubmit={createPost}>
            <div className="form-row">
              <div className="margin-bottom-1-5 flex-item">
                <Label className="label" for="category">
                  Post Category
                </Label>
                <Input
                  type="select"
                  id="category"
                  className="input-field rounded-0"
                  name="categoryId"
                  onChange={fieldChanged}
                  value={post.categoryId}
                  style={{ backgroundColor: "white", color: "black" }}
                >
                  <option disabled value="">
                    --Select category--
                  </option>
                  {categories?.map((category, index) => (
                    <option value={category._id} key={index}>
                      {category.categoryName}
                    </option>
                  ))}
                </Input>
              </div>
              <div className="margin-bottom-1-5 flex-item">
                <Label className="label" for="blog_banner">
                  Select Post Banner
                </Label>
                <Input
                  id="blog_banner"
                  name="blog_banner"
                  key={fileInputKey}
                  ref={fileInputRef}
                  type="file"
                  className="input-field"
                  onChange={uploadFiles}
                />

                {/* {bannerError && (
                  <span style={{ color: "red", fontSize: "13px" }}>
                    {bannerError}
                  </span>
                )} */}
                {bannerError ? (
                  <FormHelperText error>{bannerError}</FormHelperText>
                ) : (
                  <FormHelperText>
                    Allowed file type{" "}
                    {allowedExtensions.map((format) => `.${format}`).join(", ")}{" "}
                    with max size {maxSize / (1024 * 1024)} MB
                  </FormHelperText>
                )}
              </div>
            </div>
            <div className="margin-bottom-1-5 flex-item">
              <Label className="label" for="title">
                Post Title{" "}
                {edit.updatePost && (
                  <span style={{ color: "red" }}>Can not be Edit</span>
                )}
              </Label>
              <Input
                disabled={edit.updatePost}
                type="text"
                id="title"
                placeholder="Enter here"
                className="input-field rounded-0"
                name="title"
                value={post.title}
                onChange={fieldChanged}
              />
            </div>
            <div className="form-row">
              <div className="margin-bottom-1-5 flex-item">
                <Label className="label" for="category">
                  MetaTags
                </Label>
                <Input
                  type="text"
                  id="metatag"
                  placeholder="Enter here"
                  className="input-field rounded-0"
                  name="metatag"
                  value={post.metatag}
                  onChange={fieldChanged}
                />
              </div>
              <div className="margin-bottom-1-5 flex-item">
                <Label className="label" for="blog_banner">
                  Description
                </Label>
                <Input
                  type="text"
                  id="description"
                  placeholder="Enter here"
                  className="input-field rounded-0"
                  name="description"
                  value={post.description}
                  onChange={fieldChanged}
                />
              </div>
            </div>

            <div className="margin-bottom-1-5 jodit">
              <Label className="label" for="content">
                Post Content
              </Label>
              <JoditEditor
                ref={editor}
                value={post.content}
                onChange={contentFieldChanged}
                className="jodit-editor"
              />
            </div>

            <div className="" style={{ display: "flex" }}>
              <Button type="submit" className="button button-submit rounded-0">
                {edit.updatePost == true ? "Update Blog" : "Create Blog"}
              </Button>
              {edit.updatePost == true ? (
                ""
              ) : (
                <Button
                  type="button"
                  className="button button-reset rounded-0 ms-2"
                  onClick={handleReset}
                  style={{ backgroundColor: "#ddd" }}
                >
                  Reset Content
                </Button>
              )}
            </div>
          </Form>
        )}
      </div>
      <MaterialReactTable table={table} />
    </>
  );
};

export default Blog;
